import { useRef, useState } from "react";
import { Box, colors } from "@material-ui/core";
import { IoMdCamera, IoMdClose } from "react-icons/io";
import _ from "lodash";

import { useStyles } from "./RoundedImageChooser.style";

export type SizeTypes = "medium" | "large";

export interface RoundedImageChooserProps {
  defaultFile?: any;
  onImageSelected?: (file: any) => void;

  size?: SizeTypes;
  label?: string;
}

export function RoundedImageChooser(props: RoundedImageChooserProps) {
  const classes = useStyles(props);
  const { size, defaultFile, onImageSelected } = props;
  const inputId = _.uniqueId("rounded-image-chooser-");
  const imageInputRef = useRef();
  // State
  const [file, setFile] = useState(defaultFile);

  const handleUpload = (event) => {
    let newFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(newFile);

    // Read to display
    reader.onloadend = function (e) {
      setFile(reader.result);
    };

    if (onImageSelected !== null && onImageSelected !== undefined) {
      onImageSelected(event.target.files[0]);
    }
  };

  const handleRemoveImage = () => {
    setFile(null);
    // @ts-ignore
    imageInputRef.current.value = "";

    if (onImageSelected !== null && onImageSelected !== undefined) {
      onImageSelected(null);
    }
  };

  return (
    <Box
      className={classes.roundedWrapper}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <div className="content">
        <img
          src={file ? file : process.env.PUBLIC_URL + "/user_avatar.png"}
          alt=""
        />
        <input
          accept="image/*"
          ref={imageInputRef}
          className={classes.input}
          id={inputId}
          type="file"
          onChange={handleUpload}
        />
      </div>
      {file ? (
        <Box
          className="floatChooser"
          display="flex"
          alignItems="center"
          justifyContent="center"
          onClick={handleRemoveImage}
        >
          <IoMdClose
            color={colors.common.white}
            size={size === "medium" ? 14 : 20}
          />
        </Box>
      ) : (
        <label htmlFor={inputId}>
          <Box
            className="floatChooser"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <IoMdCamera
              color={colors.common.white}
              size={size === "medium" ? 14 : 20}
            />
          </Box>
        </label>
      )}
    </Box>
  );
}

RoundedImageChooser.defaultProps = {
  variant: "rounded",
  size: "medium",
};
